export enum SURVEY_LETTER_STEP {
	STEP_1,
	STEP_2,
	STEP_3,
}
